import React from 'react';
import PT from 'prop-types';

const AvailableDaysCounter = ({ daysAvailableByType }) => {

	return (
		<div className="available-days-counter"
			data-testid="available-days-counter">
			<div className="available-days-counter__title">
				{daysAvailableByType.length ? 'Available to you' : 'No available days yet'}
			</div>
			{
				daysAvailableByType.map(allocationType =>
					<div className="available-days-counter__item" key={Math.random()}>
						<div className="available-days-counter__item-content">
							<span className="available-days-counter__allocation-type">
								{allocationType.type}
							</span>
							<span className="available-days-counter__days-amount"
							data-testid={`available-days-counter-item-days-amount-${allocationType.type}`}>
								{`${allocationType.daysLeft} day${allocationType.daysLeft !== 1 ? 's' : ''}`}
							</span>
						</div>
					</div>)
			}
		</div>
	);
};

AvailableDaysCounter.propTypes = {
	daysAvailable: PT.number
};

export default AvailableDaysCounter;
